export const SET_MENU_ACTIVE = 'SET_MENU_ACTIVE';
export const SET_SEARCH_KEYWORD = 'SET_SEARCH_KEYWORD';
export const SET_DOWNLOAD_VISIBLE = 'SET_DOWNLOAD_VISIBLE';
export const SET_ABOUT_VISIBLE = 'SET_ABOUT_VISIBLE';
export const SET_OPERATION_MENU_VISIBLE = 'SET_OPERATION_MENU_VISIBLE';
export const SET_TICK = 'SET_TICK';
export const SET_HOT_LENOVO_VISIBLE = 'SET_HOT_LENOVO_VISIBLE';
export const SET_PINPOP_VISIBLE = 'SET_PINPOP_VISIBLE';
export const SET_PINPOP_CLOSE_VISIBLE = 'SET_PINPOP_CLOSE_VISIBLE';
export const SET_DOWNLOAD_PATH_VISIBLE = 'SET_DOWNLOAD_PATH_VISIBLE';
export const SET_PHONE_VISIBLE = 'SET_PHONE_VISIBLE';
export const SET_CAN_BACK = 'SET_CAN_BACK';
export const SET_CHECK_UPDATE_VISIBLE = 'SET_CHECK_UPDATE_VISIBLE';
export const SET_NEW_VERSION_INFO = 'SET_NEW_VERSION_INFO';
export const SET_IFRAME_VISIBLE = 'SET_IFRAME_VISIBLE';
export const SET_DETAIL_COMMENT_VISIBLE = 'SET_DETAIL_COMMENT_VISIBLE';
export const SET_RELEASE_NOTES_VISIBLE = 'SET_RELEASE_NOTES_VISIBLE';
export const SET_USER_FEEDBACK_VISIBLE = 'SET_USER_FEEDBACK_VISIBLE'; // 用户反馈
export const SET_TOP_IMG_VIDEO_VISIBLE = 'SET_TOP_IMG_VIDEO_VISIBLE'; // 头部图片视频
export const SET_SHARE_VISIBLE = 'SET_SHARE_VISIBLE';
export const SET_SHARE_LINK = 'SET_SHARE_LINK';
export const SET_FASTER_PRODUCT = 'SET_FASTER_PRODUCT';
export const SET_MAXIMIZE = 'SET_MAXIMIZE';
export const SET_MESSAGE_VISIBLE = 'SET_MESSAGE_VISIBLE';
export const SET_MESSAGE_ACTIVE_TAB = 'SET_MESSAGE_ACTIVE_TAB';

export const MENUS_CAN_BACK = ['recommend'];
export const SET_FIRST_RUN = 'SET_FIRST_RUN';
// 5.4 新增安装安卓应用成功提醒 2020-7-8 16:14:49
export const IN_TIME_INSTALLED_SOFT = 'IN_TIME_INSTALLED_SOFT';
// 5.4 菜单上的小红点
export const IS_SHOW_MENU_SPOT = 'IS_SHOW_MENU_SPOT';
// 5.4 是否打开静默安装功能
export const SET_IS_ENABLED_SILENT = 'SET_IS_ENABLED_SILENT';
// 7.5 商店主题
export const SET_STORE_THEME = 'SET_STORE_THEME';
// 7.5 商店模式
export const SET_STORE_SYSTEM_TYPE = 'SET_STORE_SYSTEM_TYPE';
// 8.3 创建壁纸快捷方式
export const CREATE_SHORTCUT = 'CREATE_SHORTCUT';

export const SET_CLEAN_TO_DSTORE_VISIBLE = 'SET_CLEAN_TO_DSTORE_VISIBLE';
// 8.6 存放窗口大小信息
export const CHANGE_WINDOW_SISE = 'CHANGE_WINDOW_SISE';
// 8.7预约成功弹窗
export const SUBSCRIBE_SUCC = 'SUBSCRIBE_SUCC';
// 8.7 预约成功LIST
export const JOIN_SUBSCRIBE_SUCC_LIST = 'JOIN_SUBSCRIBE_SUCC_LIST';
// 8.7 取消预约弹窗
export const CANCEL_SHOW = 'CANCEL_SHOW';
export const CANCEL_SUBSCRIBE_SUCC_LIST = 'CANCEL_SUBSCRIBE_SUCC_LIST';
export const NO_LOGIN_APP_SUBSCRIBE = 'NO_LOGIN_APP_SUBSCRIBE';
export const SET_OPEN_FAIL_SOFT = 'SET_OPEN_FAIL_SOFT';
export const EMPTY_OPEN_FAIL_SOFT = 'EMPTY_OPEN_FAIL_SOFT';

// 9.0.11 托盘创建弹框提醒
export const SET_TRAT_DIALOG_VISIBLE = 'SET_TRAT_DIALOG_VISIBLE';

// 默认菜单
export const MENUS = [
  'recommend',
  'game',
  'category',
  'wallpaper',
  'discount',
  'forum',
  'work',
  'education',

  'update',
  'uninstall',
];
// SMB 专针菜单
export const MENUS_SMB = [
  'work',
  'recommend',
  'education',
  'game',
  'category',
  'wallpaper',
  'discount',
  'forum',

  'update',
  'uninstall',
];
